import {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/tableapi"
export type UserAdministration_PermissionType = {
  RoleCode?: string
  Permission?: string
  HasPermission?: boolean
  PermissionDesc?: string
  Read?: boolean
  Modify?: boolean
  Add?: boolean
  Delete?: boolean
}

let columns: {
  [key in keyof UserAdministration_PermissionType]: SYSColumnDef
} = {
  Permission: {
    ui: {
      noLabel: true,
      visibility: "Table",
    },
    sortable: true,
  },

  PermissionDesc: {
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColDesc",
      readonly: true,
    },
    sortable: true,
    schema: { isCalculatedColumn: true },
  },

  HasPermission: {
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColHasPermission",
    },
    sortable: true,
    control: "checkbox",
  },

  Read: {
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColRead",
    },
    control: "checkbox",
  },
  Modify: {
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColModify",
    },
    control: "checkbox",
  },
  Add: {
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColAdd",
    },
    control: "checkbox",
  },
  Delete: {
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColDelete",
    },
    control: "checkbox",
  },
}

export let tblUserAdministration_Permission: SYSTableDef = {
  id: "SYSUserAdministration_Permission",
  feature: "SYSUserAdministration",
  permission: "SYSRA",
  database: {
    dataIdField: "Permission",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "userpermission",
  },
  features: {
    headerMenu: false,
    focusToFirstEditableField: true,
    edit: true,
    autoCloseButtonIfInsideDialog: true,
  },
  options: {
    navType: "custom",
    initial_sort: { field: "PermissionDesc", direction: "asc" },
    edit: {
      groups: {
        1: {
          className: "editgroup_modifiers",
          translationKey: "SYSUserAdministrationPermissionEditGroupModifiers",
        },
      },
    },
    controlsRendering: { fillSpaceIfNotVisible: false },
  },

  columns,
}
let resultingPermission: SYSTableDef = JSON.parse(
  JSON.stringify(tblUserAdministration_Permission)
)
resultingPermission.features.add = false
resultingPermission.features.edit = false
resultingPermission.features.delete = false
resultingPermission.features.showFooterButtons = false
resultingPermission.features.headerMenu = false

export let tblUserAdministration_ResultingPermission: SYSTableDef =
  resultingPermission
